<template>
  <custom-canvas
    v-if="config"
    :config="config"
    :locale="locale"
  />
</template>
<script>
import apiDtouch from '@/services/apiDtouch'
import CustomCanvas from './CustomCanvas'
export default {
  components: {
    CustomCanvas,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    locale: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    config: null,
  }),
  mounted () {
    this.handleGetData()
  },
  methods: {
    async handleGetData () {
      try {
        const categories = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.item.interactiveMapID}/categories`)
          .then(response => {
            if (response && response.length > 0) {
              response = response.map(item => {
                item.Name = JSON.parse(item.Name)
                return item
              })
              response.unshift({
                ID: null,
                Icon: 'mdi-folder',
                Name: { es: 'TODOS', en: 'ALL'}
              })
            }
            resolve(response)
          }).catch (error => {
            reject(error)
          }))

        const map = await new Promise((resolve, reject) => apiDtouch.getItem(`v2/public/interactive-maps/${this.item.interactiveMapID}`)
          .then(response => {
            resolve(response)
          }).catch (error => {
            reject(error)
          }))
        const points = await new Promise((resolve, reject) => apiDtouch.getAll(`v2/public/interactive-maps/${this.item.interactiveMapID}/points`)
          .then(response => {
            resolve(response.map(item => {
              item.Title = JSON.parse(item.Title)
              item.Description = JSON.parse(item.Description)
              item.Info = item.Info ? JSON.parse(item.Info) : null
              return item
            }))
          }).catch (error => {
            reject(error)
          }))
        const w = (document.getElementsByTagName('body')[0].clientWidth)
        //const scale = w > v.Width ? 1 : w / v.Width
        const scale =  w / map.Width
        const width = map.Width * scale | 0
        const height = map.Height * scale | 0

        this.config = {
          background: map.Image,
          scale,
          width,
          height,
          points,
          categories,
        }
      } catch (error) {
        console.log(error)
      }
    },
  },
}
</script>

